module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-72x72-f5636da720956212ca4539ea3f6cd9d5.png";